import { VentureJourney } from '../components/investor/VentureJourney';

export default function VentureInvestorPage({ onJoin }) {
  return <VentureJourney onJoin={onJoin} />;
}